'use client';

import { useEffect, useState } from 'react';

import { formatDuration } from '@/lib/time';

export interface RecordingCountdownProps {
  recordingStartedAtMs: number | null;
  maxRecordingDurationMs: number;
}

const WARNING_THRESHOLD_MS = 10 * 60 * 1000;

export function RecordingCountdown({
  recordingStartedAtMs,
  maxRecordingDurationMs,
}: RecordingCountdownProps) {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    if (recordingStartedAtMs === null) return;
    setNowMs(Date.now());
    const id = window.setInterval(() => { setNowMs(Date.now()); }, 1000);
    return () => { window.clearInterval(id); };
  }, [recordingStartedAtMs]);

  if (recordingStartedAtMs === null) return null;

  const remainingMs = Math.min(
    maxRecordingDurationMs,
    Math.max(0, recordingStartedAtMs + maxRecordingDurationMs - nowMs),
  );
  const isWarning = remainingMs <= WARNING_THRESHOLD_MS;
  const label = formatDuration(remainingMs);

  return (
    <span
      className={`ml-2 text-xs font-normal ${isWarning ? 'text-amber-600' : 'text-slate-500'}`}
      aria-label={`録音残り時間 ${label}`}
    >
      残り {label}
    </span>
  );
}
